// Generated by CoffeeScript 2.7.0
var Admin__MessagesController;

import TagGroupSidebar from '../../share/tag_group_sidebar.js';

import MessageGroupsModal from 'trunks/vue/admin/compositions/message_groups_modal.js';

import ToggleNavMenuAction from '../toggle_nav_menu_action.js';

export default Admin__MessagesController = (function() {
  class Admin__MessagesController extends Skylark.App.BaseController {
    index() {
      new Skylark.Elements.QueryInput(DomMaster.find('.js_query_input'));
      new Skylark.Elements.DropdownSelect(DomMaster.find('.js_create_message_dropdown'));
      this.message_list = new Skylark.Elements.MessageList(DomMaster.find('.message-groups'));
      this.__bindEditTags();
      this.__bindEditMessageGroup();
      this.__toggleNavMenu();
      new Skylark.Elements.SharePopover(DomMaster.find('.share-popover'));
      // 获取指定dom，实例化一个popover并返回
      return new Skylark.Elements.Popover(DomMaster.find('.nav-menu-popover'), {
        size: 'larger',
        type: 'prompt'
      });
    }

    __bindEditMessageGroup() {
      return document.body.proxy('click', '.js-open-edit-message-groups-modal-btn', function(event) {
        return Skylark.Libs.Ajax.get(Skylark.Helpers.UrlHelper.adminUrlFor('message_groups'), {
          responseType: 'json',
          success: function(message_groups) {
            return $currentController.message_groups_modal = new MessageGroupsModal({
              el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('message_groups_modal'),
              propsData: {
                rawMessageGroups: message_groups,
                updateUrl: Skylark.Helpers.UrlHelper.adminUrlFor('message_groups/update_collection', $currentController.getParams())
              }
            });
          },
          error: function() {
            return Skylark.Bridge.newAlertify('数据加载失败', {
              type: 'danger'
            });
          }
        });
      });
    }

    _updateMessageGroupNavGroup(content) {
      return DomMaster.find('#js_message_group_nav_group').replaceWith(content);
    }

  };

  Admin__MessagesController.include(TagGroupSidebar, ToggleNavMenuAction);

  return Admin__MessagesController;

}).call(this);
